module.exports = __webpack_public_path__ + "img/_empty_states_search.e329f934.svg";